module.exports = {
        srcSet: __webpack_public_path__ + "static/media/house-400.c656057b.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/house-400.c656057b.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/house-400.c656057b.webp",
        toString: function(){return __webpack_public_path__ + "static/media/house-400.c656057b.webp"},
        
        width: 400,
        height: 400
      }